import { FC } from 'react';

import { Chip, SxProps } from '@mui/material';

import { EProposalStatus } from '../../interfaces/proposal';

type ProposalStatus = EProposalStatus.Active | EProposalStatus.Closed | EProposalStatus.Pending;

interface StatusChipProps {
  status?: ProposalStatus;
  sx?: SxProps;
}

export const StatusChip: FC<StatusChipProps> = ({ status, sx }) => {
  switch (status) {
    case EProposalStatus.Active:
      return <Chip label={EProposalStatus.Active} size="small" color="secondary" sx={{ px: 1, ...sx }} />;

    case EProposalStatus.Closed:
      return <Chip label={EProposalStatus.Closed} size="small" color="primary" sx={{ px: 1, ...sx }} />;

    case EProposalStatus.Pending:
      return <Chip label={EProposalStatus.Pending} size="small" color="warning" sx={{ px: 1, ...sx }} />;

    default:
      return null;
  }
};
